import { useState } from 'react'
import { Box, Collapsible, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { FiAlertTriangle, FiChevronDown, FiChevronRight } from 'react-icons/fi'
import type { ConflictRow } from './conflictSummary'

interface ConflictSummaryBarProps {
  rows: ConflictRow[]
  onFlash: (meetingIdA: string, meetingIdB: string) => void
}

/** Collapsible banner above the agenda. Its collapsed state IS the "N conflicts" indicator;
 *  each row names the clash in words and flashes both cards on click. */
export function ConflictSummaryBar({ rows, onFlash }: ConflictSummaryBarProps) {
  const [open, setOpen] = useState(true)
  if (rows.length === 0) return null
  return (
    <Box mb={3} borderWidth="1px" borderColor="red.200" bg="red.50" borderRadius="md">
      <HStack
        as="button" w="full" px={3} py={2} justify="space-between"
        onClick={() => setOpen((o) => !o)}
        {...({ type: 'button' } as Record<string, unknown>)}
      >
        <HStack color="red.600" fontWeight="semibold" fontSize="sm" gap={2}>
          <Icon as={FiAlertTriangle} />
          <Text>{rows.length} conflict{rows.length === 1 ? '' : 's'}</Text>
        </HStack>
        <Icon as={open ? FiChevronDown : FiChevronRight} color="red.400" />
      </HStack>
      <Collapsible.Root open={open}>
        <Collapsible.Content>
          <VStack align="stretch" gap={0} px={3} pb={2}>
            {rows.map((r) => (
              <HStack
                key={r.key} as="button" py={1} justify="space-between"
                fontSize="sm" _hover={{ color: 'red.700' }} onClick={() => onFlash(r.meetingIdA, r.meetingIdB)}
                {...({ type: 'button' } as Record<string, unknown>)}
              >
                <Text textAlign="left">
                  <b>{r.attendeeName}</b> — {r.aLabel} {r.aTime} ↔ {r.bLabel} {r.bTime}
                </Text>
                <Text color="red.400" fontSize="xs" flexShrink={0} ml={2}>flash ›</Text>
              </HStack>
            ))}
          </VStack>
        </Collapsible.Content>
      </Collapsible.Root>
    </Box>
  );
}
